var industryInfo={
    classList:[
        {
            'name':"机器视觉系统",
            'list':[
                {
                    'videoUrl':"https://image.sjyuan.net.cn/video/mvb/case/FM851.mp4",
                    'title':"物流行业自动供包",
                    'lable':"在电商或智能制造行业中，无序分拣在拣选、上下料、柔性生产中的需求正在爆发，在电子制造、汽车生产等多种生产行业和电商中有巨大的潜在应用需求，这类需求通常物体的形状多样、无序程度高，需要更高精度的相机和更先进的算法。",
                    'list':[
                        {
                            'icon':"/static/case/clfwd.png",
                            'title':"测量范围和景深大"
                        },
                        {
                            'icon':"/static/case/ptkf.png",
                            'title':"支持各种2D+3D算法"
                        },
                        {
                            'icon':"/static/case/ptkf.png",
                            'title':"提供强大的软件和算法支持"
                        }
                        ,
                        {
                            'icon':"/static/case/ptkf.png",
                            'title':"软件和硬件持续迭代更新"
                        }
                    ]
                }
            ]
        },
       
    ],
    name:"仓储物流",
    title:"solutions",
    subtitle:"仓储物流应用案例",
    subinfo:"我们的应用案例包括应用于仓储物流配合工业机器人工作的机器视觉系统，可提供丰富的视觉信息。",
}

export default {
    industryInfo
  };


// WEBPACK FOOTER //
// ./src/data/industryInfo/4.js